import { ChevronLeft } from '@mui/icons-material';

const BackButtonContent = () => {
  return (
    <>
      <ChevronLeft className="tw:text-2xl" />
      <span className="tw:text-xs">Back</span>
    </>
  );
};

export default BackButtonContent;
